import { find } from 'lodash';
import { Commands } from 'types/aspen/commands';
import { SupportedCommand, SupportedCommands } from 'types/aspen/supportedCommands';

export const createCommand = <T extends keyof Commands>(command: T, parameters: Commands[T]) => ({
  command,
  parameters: {
    [command]: parameters,
  },
});

export const findSupportedCommand = <T extends keyof Commands>(supportedCommands: SupportedCommands, command: T) =>
  find(supportedCommands, { type: command }) as Extract<SupportedCommand, { type: T }> | undefined;

export const isCommandSupported = (supportedCommands: SupportedCommands, command: keyof Commands) =>
  !!find(supportedCommands, { type: command });
